module.exports = false;



//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-v2.3/~/core-js/modules/_library.js
// module id = 285
// module chunks = 0